export const WAREHOUSE_SETTINGS_ROOT = "/settings/warehouse";
export const PURCHASE_ORDER_ROOT = "/purchase-order";